module.exports = __webpack_public_path__ + "cluster.svg?9f750c22bdc13c335e3b6347096c636e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cluster.svg
// module id = 132
// module chunks = 0